import React from "react";
import { principles } from "../data/content";

export default function Principles() {
  return (
    <section id="principles" className="section-pad border-t border-rule">
      <div className="wrap">
        <header className="reveal mb-12 max-w-3xl">
          <p className="label">06 / How I work</p>
          <h2 className="mt-4 font-display text-[clamp(1.75rem,3vw,2.5rem)] font-semibold tracking-[-0.02em]">
            Engineering principles
          </h2>
        </header>

        <ol className="grid gap-px border border-rule bg-rule md:grid-cols-2 lg:grid-cols-3">
          {principles.map((item, index) => (
            <li key={item.title} className="reveal bg-canvas-raised p-6 md:p-8">
              <p className="label">
                {String(index + 1).padStart(2, "0")}
              </p>
              <h3 className="mt-3 font-display text-lg font-semibold tracking-tight">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-ink-secondary">{item.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
